module.exports = __webpack_public_path__ + "media/2.378e6a47.mp3";